import { Component } from '@angular/core';

/**
 * Generated class for the Spinner_1Component component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'spinner-1',
  templateUrl: 'spinner-1.html'
})
export class Spinner_1Component {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/spinner-1/spinner-1.ts